module.exports = __webpack_public_path__ + "img/晴.a52608b0.png";